<div
  *ngIf="isVisible"
  class="calendar"
  [ngClass]="{ 'calendar--extension': isExtension }"
  (window:resize)="onResize($event)"
>
  <div *ngIf="showInaccessibleError" class="calendar__error">{{ 'calendar-error' | translate }}</div>
  <div *ngIf="showSelectDatesMessage && !showInaccessibleError" class="calendar__message">
    <i class="fa-regular fa-calendar-plus calendar__message-icon"></i>
    {{ 'calendar-select-dates-message' | translate }}
  </div>

  <div *ngIf="!showSelectDatesMessage && dateRange && calendarType === 'pdp'" class="calendar__message-warning">
    <i class="fa-regular fa-info-circle calendar__message-icon"></i>
    {{ 'calendar-select-dates-warning' | translate }}
  </div>

  <div *ngIf="isEmptyDates" class="calendar__error">{{ 'calendar-empty-dates' | translate }}</div>
  <div
    class="calendar__inner"
    [ngClass]="{
      'calendar__inner--footer-opened': visibleBookedDates
    }"
  >
    <button
      class="calendar__button-close"
      type="button"
      [ngClass]="{ 'calendar__button-close--light': showInaccessibleError || showSelectDatesMessage }"
      (click)="closeCalendar()"
    >
      <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10 1H30C34.9706 1 39 5.02944 39 10V30C39 34.9706 34.9706 39 30 39H10C5.02944 39 1 34.9706 1 30V10C1 5.02944 5.02944 1 10 1Z"
          stroke="currentColor"
          stroke-width="2"
        />
        <g clip-path="url(#clip0_30908_24566)">
          <path
            d="M25.3789 16.0664L21.1602 20.2852L25.3438 24.4688C25.6953 24.7852 25.6953 25.3125 25.3438 25.6289C25.0273 25.9805 24.5 25.9805 24.1836 25.6289L19.9648 21.4453L15.7812 25.6289C15.4648 25.9805 14.9375 25.9805 14.6211 25.6289C14.2695 25.3125 14.2695 24.7852 14.6211 24.4336L18.8047 20.25L14.6211 16.0664C14.2695 15.75 14.2695 15.2227 14.6211 14.8711C14.9375 14.5547 15.4648 14.5547 15.8164 14.8711L20 19.0898L24.1836 14.9062C24.5 14.5547 25.0273 14.5547 25.3789 14.9062C25.6953 15.2227 25.6953 15.75 25.3789 16.0664Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_30908_24566">
            <path
              d="M8 18C8 12.4772 12.4772 8 18 8H22C27.5228 8 32 12.4772 32 18V22C32 27.5228 27.5228 32 22 32H18C12.4772 32 8 27.5228 8 22V18Z"
              fill="white"
              transform="translate(0.333008)"
            />
          </clipPath>
        </defs>
      </svg>
    </button>
    <div class="calendar__header" [ngClass]="{ 'calendar__header--extension': isExtension }">
      <ng-container *ngIf="!isExtension">{{ 'calendar-choose-dates' | translate }}</ng-container>
      <ng-container *ngIf="isExtension">{{ 'calendar-select-new-checkout-date' | translate }}</ng-container>
    </div>
    <div class="calendar__content">
      <div #scrollContainer class="calendar__scroll-content">
        <div class="calendar__month-label" [ngClass]="{ 'calendar__month-label--extension': isExtension }">
          <span>{{ monthName | translate }}</span>
          {{ year }}
        </div>
        <div class="calendar__months">
          <ngb-datepicker
            *ngIf="I18n.visibleDatePicker && isVisible"
            #dp
            firstDayOfWeek="1"
            outsideDays="hidden"
            [displayMonths]="displayMonths"
            [dayTemplate]="dayTemplate"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [startDate]="calendarStartDate"
            (dateSelect)="onDateSelection($event)"
            (navigate)="navigate($event)"
          />
          <ng-template #dayTemplate let-date let-focused="focused">
            <span
              #day
              [attr.class]="
                'calendar__month-week-date calendar__month-week-date-' +
                date.year +
                '-' +
                (date.month < 10 ? '0' + date.month : date.month) +
                '-' +
                (date.day < 10 ? '0' + date.day : date.day) +
                (isExtension ? ' calendar__month--range--extension' : '')
              "
              [ngClass]="{
                'calendar__month--range ngb-dp-day--range':
                  date | isRange: fromDate : toDate : hoveredDate : daysInfoObj : day,
                'calendar__month--start-date ngb-dp-day--start-date':
                  date | isStartDate: fromDate : toDate : hoveredDate,
                'calendar__month--end-date ngb-dp-day--end-date': date | isEndDate: fromDate : toDate : hoveredDate,
                'calendar__month--date-selected ngb-dp-day--date-selected': date | isDateSelected: fromDate : toDate
              }"
              [attr.id]="'qa_calendar-day-' + date.month + '-' + date.day + '-' + date.year"
              [class.focused]="focused"
              (mouseenter)="hoveredDate = date"
              (mouseleave)="hoveredDate = null"
            >
              {{ date.day | formatDay: date : daysInfoObj : day : fromDate : toDate : extensionToDate }}
            </span>
          </ng-template>
        </div>
      </div>
    </div>

    <div *ngIf="visibleBookedDates && selectedDates.length" class="calendar__footer">
      <div class="calendar__selected-dates">
        <div>
          {{ 'calendar-check-in' | translate }}
          <span
            ><span>{{ selectedDates[0] | formatDate: 'dd' : I18n.currentLang }}</span>
            {{ selectedDates[0] | formatDate: 'MMM' : I18n.currentLang }}</span
          >
        </div>
        <div *ngIf="selectedDates.length > 1">
          {{ 'calendar-check-out' | translate }}
          <span>
            <span>{{ selectedDates[selectedDates.length - 1] | formatDate: 'dd' : I18n.currentLang }}</span>
            {{ selectedDates[selectedDates.length - 1] | formatDate: 'MMM' : I18n.currentLang }}
          </span>
        </div>
      </div>
      <button
        class="btn btn-cta"
        type="button"
        [disabled]="selectedDates.length === 1 || showInaccessibleError"
        (click)="confirmBookedDates()"
      >
        <span class="calendar__button-text">{{ 'calendar-confirm' | translate }}</span>
      </button>
    </div>
  </div>
</div>
